import react from "react";


const INITIALSTATE = {
    data: []
}

const OrderStatusReducer = (state = INITIALSTATE, action) => {
    switch (action.type) {
        case "GetStatus":
            return { ...state, data: action.data };
        default: return state;
    };
}
export default OrderStatusReducer;